import {
  Button,
  Icon,
  Field as ToolkitField
} from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import useIsOpen from 'shared/hooks/useIsOpen'
import HtmlEditorModal from './HtmlEditorModal'
import InformationalHtmlField from './InformationalHtmlField/InformationalHtmlField'

type HtmlEditorFieldProps = {
  field: ToolkitField & {
    columns?: string[]
    informational?: boolean
  }
  value: string
  isEditing?: boolean
  isEditable: boolean
  disabled?: boolean
  informational?: boolean
  onChange: (value: string) => void
}

const HtmlEditorField = ({
  field,
  value,
  isEditing,
  isEditable,
  onChange
}: HtmlEditorFieldProps) => {
  const { isOpen, open, close } = useIsOpen(false)
  const { t } = useTranslation()
  const label = field.display_text.des

  const editButton =
    isEditing && isEditable ? (
      <Button
        type='button'
        variant='secondary'
        heightClass='extraSmall'
        onClick={open}
        title={label}
        data-testid={`html-editor-edit-${field.column_json}`}
        style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
      >
        {t('data-tables.edit')}
        <Icon iconName='Edit' icSize='extraSmall' />
      </Button>
    ) : null

  return (
    <>
      <InformationalHtmlField
        label={label}
        html={value}
        actionButton={editButton}
      />
      <HtmlEditorModal
        isOpen={isOpen}
        title={label}
        initialContent={value}
        onClose={close}
        onConfirm={onChange}
      />
    </>
  )
}

export default HtmlEditorField
